import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { Navigate , Route } from "react-router-dom";
import Header  from './header'; 
import BreadCrumb from './breadcrumb';
import MUIDataTable from "mui-datatables";
import DatePicker from "react-datepicker";
import $ from 'jquery';
import "react-datepicker/dist/react-datepicker.css";  
const ExampleCustomTimeInput = ({ date, value, onChange }) => (
  <input
    value={value}
    onChange={(e) => onChange(e.target.value)}
    style={{ border: "solid 1px pink" }}
  />
);
class AddBids extends Component {
 
    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            username:'',
            password:'',
            addedBy:'',
            selectedDate:'',
            valueDate:'',
            valueTime:'',
            bidNum:'',
            bidAmount:'',
            bidAuction:'',
            printDate:'',
            bids: []
        };

        this.handleSubmit = this.handleSubmit.bind(this); 
        this.handleSubmitAuto = this.handleSubmitAuto.bind(this);
       
    }

    componentDidMount(){
        var loaderElement = document.querySelector('#load_screen');
        setTimeout( function() {
            loaderElement.style.display = "none";
        }, 3000); 
   
        this.setState({addedBy: "Admin - "+localStorage.getItem("NAME")})
        $("#ManualBids").hide();
        $("#autoBids").hide();
      //$("#bidDate").inputmask("99/99/9999");
      $(".manualBidsBtn").on("click",function(){
        $("#ManualBids").show();
        $("#autoBids").hide();
      })

      $(".autoBidsBtn").on("click",function(){
        $("#ManualBids").hide();
        $("#autoBids").show();
      })
      //  ManualBids autoBids
    
     this.getSpecificBids();
    
    }
 
    setStartDate(date){
      console.log(date,date.toISOString())
      this.setState({printDate:date.toLocaleDateString()})
      this.setState({selectedDate:date})
      this.setState({valueDate:date.toISOString()})
      this.setState({valueTime: date.toLocaleTimeString()})
      console.log(this.state.printDate)
     }

    updatePassword(event){
         
        this.setState({password:event.target.value})
        console.log(this.state.password);

    }
    
    updateDate(event){
      this.setState({valueDate:event.target.value})
    }
    
    updateTime(event){
      this.setState({valueTime:event.target.value})
    }
    
    updateAuctionNumber(event){
      this.setState({bidAuction:event.target.value})
    }

    updateBidAmount(event){
      this.setState({bidAmount:event.target.value})
    }

    updateBidNumber(event){
      this.setState({bidNum:event.target.value})
    }

    getSpecificBids( ) {
      let self = this;
      var bidsDetails = new FormData();
      bidsDetails.append('user',localStorage.getItem("USERID"));
      bidsDetails.append('OP', 'getOpenBids');
      axios.post('http://sktrading.biz/BMSCalls/bids.php',bidsDetails)
            .then(function (response) {
              console.log("BIDS",response);
              if(response.data.status== "true" || response.data.status== true){ 
              var data = [];
              for(var i = 0; i < response.data.response.length; i++){
              data.push(
                 [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount'],response.data.response[i]['bidStatus']
                 ],
              )
            }
             self.setState({bids:data});
              // if(response.data.status =='true'){
              
              //     toast.success(response.data.response, {
              //         position: "top-right",
              //         autoClose: 5000,
              //         hideProgressBar: false,
              //         closeOnClick: true,
              //         closeButton:false,
              //         pauseOnHover: true,
              //         draggable: true,
              //         progress: undefined,
              //         });
                    
              // }else{
              //     toast.error(response.data.response, {
              //         position: "top-right",
              //         autoClose: 5000,
              //         hideProgressBar: false,
              //         closeOnClick: true,
              //         closeButton:false,
              //         pauseOnHover: true,
              //         draggable: true,
              //         progress: undefined,
              //         });
                
              //   }
            }})
            .catch(function (error) {
              console.log(error);
            });

    }
    
    handleSubmitAuto(event){
      const dateFormat = 'YYYY-MM-DD';
      var moment = require('moment-timezone');
      var date = moment("2016-10-19");
      let self = this;
      console.log("BIDS",this.state.bidAuction.split(">").length);
    
      var date = moment(this.state.bidAuction.split(">")[0]); 
      let options = {  
        hour: "2-digit", minute: "2-digit" 
    };
      var time = moment(this.state.bidAuction.split(">")[3]);
       
      if(date.format('YYYY-MM-DD')=='Invalid date'){
        toast.error("Entered Date is Invalid Please Enter like this 2022-06-16", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          closeButton:false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
        
      } 
      
      if(this.state.bidAuction.split(">").length ==4){
        if(this.state.bidAmount.length>0 ){
          let val = Number(this.state.bidAuction.split(">")[2]);
          const re =/^[0-9.,]+$/;
          let isnum = re.test(val);
          console.log(typeof(val),val + "-" +isnum);
          if (isnum) {
            var bidsDetails = new FormData();
            bidsDetails.append('date', this.state.bidAuction.split(">")[0]);
            bidsDetails.append('time', this.state.bidAuction.split(">")[3]);
            bidsDetails.append('bid_auction',this.state.bidAuction.split(">")[1]);
            bidsDetails.append('bid_no',this.state.bidAuction.split(">")[2]);
            bidsDetails.append('bid_amount',this.state.bidAmount);
            bidsDetails.append('bidding_date',date.format('YYYY-MM-DD')+" "+this.state.bidAuction.split(">")[3])
            bidsDetails.append('bidding_user',localStorage.getItem("USERID"));
            bidsDetails.append('OP', 'createBid');
            axios.post('http://sktrading.biz/BMSCalls/bids.php',bidsDetails)
            .then(function (response) {
              console.log("BIDS",response);
              if(response.data.status =='true'){
                //client_nameclient_password
                $("#client_name").val("");
                $("#client_password").val("");
                self.setState({bidAuction:' ',bidAmount:' '})
                self.getSpecificBids();
                
                  toast.success(response.data.response, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      closeButton:false,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      });
                    
              }else{
                  toast.error(response.data.response, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      closeButton:false,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      });
                
                }
            })
            .catch(function (error) {
              console.log(error);
            });
          }else{
            toast.error("Invalid Bid Number.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              closeButton:false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              });
          }
        }else{
          toast.error("Bidding Amount is required.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            closeButton:false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
        }
      
      }else{
        toast.error("Invalid Parameters, Please Enter Date > Auction Name > Bid Number > Time", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          closeButton:false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
     
      event.preventDefault();
    }

    handleSubmit(event) {
      let self = this;
      var bidsDetails = new FormData();
      bidsDetails.append('date', this.state.valueDate);
      bidsDetails.append('time', this.state.valueTime);
      bidsDetails.append('bid_auction',this.state.bidAuction);
      bidsDetails.append('bid_no',this.state.bidNum);
      bidsDetails.append('bid_amount',this.state.bidAmount);
      bidsDetails.append('bidding_user',localStorage.getItem("USERID"));
      bidsDetails.append('OP', 'createBid');
      axios.post('http://sktrading.biz/BMSCalls/bids.php',bidsDetails)
        .then(function (response) {
          console.log("BIDS",response);
          if(response.data.status =='true'){
            self.setState({valueDate:' ',valueTime:' ',bidAuction:' ',bidNum:' ',bidAmount:' '})
            self.getSpecificBids();
              toast.success(response.data.response, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  closeButton:false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  });
                
          }else{
              toast.error(response.data.response, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  closeButton:false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  });
               //   window.location.pathname = '/dashboard'
            }
        })
        .catch(function (error) {
         // window.location.pathname = '/dashboard'
          console.log(error);
        });
          
        event.preventDefault();

      }
    
    render (){
      const columns = ["Date", "Time", "Bidder", "Auction", "Bid Number", "Amount","Bid Status"];
      const options = {
        filterType: 'checkbox',
        count: 20, 
        print: false
        };
      let handleColor = (time) => {
        return time.getHours() > 12 ? "text-success" : "text-error";
      };
      //  const {products, addToCart, symbol, addToWishlist, addToCompare} = this.props;
      return (
        <div>
         {/* BEGIN LOADER */}
        <div id="load_screen"> <div className="loader"> <div className="loader-content">
              <div className="spinner-grow align-self-center" />
            </div></div></div>
        {/*  END LOADER */}
        {/*  BEGIN NAVBAR  */}
        <Header/>
        {/*  END NAVBAR  */}
        {/*  BEGIN MAIN CONTAINER  */}
        <div className="main-container" id="container">
          <div className="overlay" />
          <div className="search-overlay" />
          {/*  BEGIN CONTENT AREA  */}
          <div id="content" className="main-content">
            <div className="layout-px-spacing">
              <BreadCrumb/>
              <div className="row layout-top-spacing layout-spacing">
                <div id="flLoginForm" className="col-lg-12 layout-spacing">
                  <div className="statbox widget box box-shadow">
                    <div className="widget-header">
                      <div className="row">
                        <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                          <h4 id="registerString"  > <span id="bidText" className="manualBidsBtn" > Add Bids Manually </span>   <span id="bidText" className="autoBidsBtn" > Add Auto Bids</span></h4>
                        </div>
                      </div>
                    </div>
                    <div className="widget-content widget-content-area">
                      <form id="ManualBids" onSubmit={this.handleSubmit}>
                        <div className="form-group mb-4">
                          <input type="text"className="form-control" id="parent_id"
                          value={this.state.addedBy}
                           placeholder="Added By:" disabled   />
                        </div>

                        <div class="row">

                        <div className="col-md-6">
                        <div className="form-group mb-2">
                          <input type="text" className="form-control" id="bidDate" placeholder="Bid Date"  data-mask="(999) 999-9999"  
                          value={this.state.valueDate}
                          onChange={(e) => {this.updateDate(e)}}  />
                        </div>
                        </div>

                        <div className="col-md-6">
                        <div className="form-group mb-2">
                          <input type="text" className="form-control" id="client_name" 
                          value={this.state.valueTime}
                           placeholder="Bid Time"  onChange={(e) => {this.updateTime(e)}}  />
                        </div>
                        </div>
                        </div>
                      
 
                        {/* <div className="form-group mb-4">
                          { <input type="text" className="form-control" id="client_update_date" placeholder="Bid Date / Time" /> }
                          <DatePicker 
                          selected={this.state.selectedDate}
                          onChange={(date) => this.setStartDate(date)}
                          className="form-control"
                          placeholderText="Bid Date / Time"
                          showTimeSelect
                          timeClassName={handleColor}
                        />
                        <small id="placeholderHelp" style={{'fontSize':'15px'}} className="form-text text-muted" > {"Bid Date / Time  - "+ this.state.printDate + " | "+ this.state.valueTime} </small>
                       
                        </div> */}
                      
                        <div className="form-group mb-4">
                          <input type="text" className="form-control"
                           id="client_name" placeholder="Auction Name" 
                           value={this.state.bidAuction}
                            onChange={(e) => {this.updateAuctionNumber(e)}}  />
                        </div>
                        <div className="form-group mb-4">
                          <input type="text" className="form-control" 
                          id="client_user" placeholder="Bid Number"
                          value={this.state.bidNum}
                           onChange={(e) => {this.updateBidNumber(e)}} />
                        
                        </div>
                        <div className="form-group mb-4">
                          <input type="text" className="form-control" 
                             value={this.state.bidAmount}
                          id="client_password" placeholder="Bid Amount" onChange={(e) => {this.updateBidAmount(e)}} />
                          <small id="placeholderHelp" className="form-text text-muted">Example: 250000 CF as it is </small>
                        </div>
                        
                        
                        <small id="emailHelp" className="form-text text-muted">*Required Fields</small>
                        <button type="submit" id="btnRegis" className="btn btn-primary mt-4">Proceed</button>
                        <ToastContainer />
                      </form>
     
                      <form id="autoBids" onSubmit={this.handleSubmitAuto}>
                        <div className="form-group mb-4">
                          <input type="text"className="form-control" id="parent_id"
                          value={this.state.addedBy}
                           placeholder="Added By:" disabled   />
                        </div>
 
                       
                      
                        <div className="form-group mb-4">
                         
                         <input type="text" className="form-control" id="client_name" placeholder="Details"
                         value={this.state.bidAuction}
                         onChange={(e) => {this.updateAuctionNumber(e)}}  /> 

                        <small id="placeholderHelp" className="form-text text-muted">2022-05-13 > MIRIVE Aichi > 10002 > 10:35:00 </small>
                        </div>
                        
                        <div className="form-group mb-4">
                          <input type="text" className="form-control" id="client_password" placeholder="Bid Amount"
                          value={this.state.bidAmount}
                           onChange={(e) => {this.updateBidAmount(e)}} />
                          <small id="placeholderHelp" className="form-text text-muted">Example: 250000 CF as it is</small>
                        </div>
                        
                        
                        <small id="emailHelp" className="form-text text-muted">*Required Fields</small>
                        <button type="submit" id="btnRegis" className="btn btn-primary mt-4">Proceed</button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>

                
              </div>

              <div className="row layout-top-spacing layout-spacing">
              <div id="flLoginForm" className="col-lg-12 layout-spacing">
              <MUIDataTable
                title={"All Open Bids"}
                data={this.state.bids}
                columns={columns}
                options={options}
                />
              </div> </div>

              <div className="footer-wrapper">
                <div className="footer-section f-section-1">
                  <p className>Copyright © 2022 <a target="_blank" href>BMS</a>, All rights reserved.</p>
                </div>
                <div className="footer-section f-section-2">
                  <p className>Coded with <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg></p>
                </div>
              </div>
              {/* BEGIN GLOBAL MANDATORY SCRIPTS */}
              {/* END GLOBAL MANDATORY SCRIPTS */}
              {/* BEGIN PAGE LEVEL SCRIPTS */}
              {/* END PAGE LEVEL SCRIPTS */}
            </div>
          </div>
          {/* END MAIN CONTAINER */}
        </div>
        </div>
      );
    }
}
const mapStateToProps = (state) => ({
 
})
 
export default AddBids; 